/**
 * Universal search, asked of the server. Screens import this, never the server.
 * The server decides what is found and what this person may open
 * (src/core/search).
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { orpc } from '@/adapters/rpc/client'
import { useDebounced } from '@/features/shared/hooks/use-debounced'

export function useSearch(query: string) {
  const q = useDebounced(query.trim())
  return useQuery({
    ...orpc.search.query.queryOptions({ input: { q } }),
    enabled: q.length > 0,
    // Keep showing the last results while the next ones load, so the list
    // doesn't flash empty between keystrokes.
    placeholderData: keepPreviousData,
    // Always ask again: a colleague may have just created the thing you want.
    staleTime: 0,
  })
}
